import Scroll from '../services/Scroll'

export default class PositionObserver2 {
    constructor(element, options) {
        this.options = {
            rootMargin: '50% 0% 50% 0%',
            //full = 0-1 (0 - zacina vjizdet element do viewportu, 1 - vyleze posledni pixel nahore)
            //bottom = 0-1 (0 - zacina vjizdet element do viewportu, 1 - je videt 100% elementu)
            normalizeInitialViewport: false,
            ratioAlign: 'center',
            ratioAlign: 'center',
            ...options
        }

        this.element = element
        this.rect = null
    }

    observe() {
        this.observer = new IntersectionObserver(this.handleIntersection, {
            threshold: 0,
            rootMargin: this.options.rootMargin
        })
        this.observer.observe(this.element)
    }

    destroy() {
        this.detach()
        this.observer?.disconnect()
    }

    handleIntersection = (entries) => {
        entries.forEach((entry) => {
            if (entry.target !== this.element) {
                return
            }
            if (entry.isIntersecting) {
                this.attach()
            } else {
                this.detach()
            }
        })
    }

    attach() {
        if (this.isAttached) {
            return
        }
        this.resize()

        Scroll.on("resize", this.handleResize)
        Scroll.on("scroll", this.handleScroll)
        this.isAttached = true
        this.options.onEnter?.()
    }

    detach() {
        if (!this.isAttached) {
            return
        }
        Scroll.off("resize", this.handleResize)
        Scroll.off("scroll", this.handleScroll)
        this.isAttached = false
        this.options.onLeave?.()
    }

    handleScroll = () => {
        this.update()
    }

    handleResize = () => {
        this.resize()
    }

    update() {
        if (!this.options.onRender) {
            return
        }

        let deltaTotal = 0
        let deltaCurrent = 0

        if (this.options.normalizeInitialViewport) {
            deltaTotal = Math.min(0, this.rect.documentTop - Scroll.window.height)
        }

        if (this.options.ratioAlign === 'bottom') {
            deltaTotal = -Scroll.window.height
            deltaCurrent = -Scroll.window.height
        }

        const total = Scroll.window.height + this.rect.height + deltaTotal
        const current = this.rect.documentTop - Scroll.getScroll().y + this.rect.height + deltaCurrent

        let ratio = Math.max(Math.min(current / total, 1), 0)

        if (this.options.ratioAlign === 'center' && !this.options.normalizeInitialViewport) {
            ratio = (.5 - ratio) * 2
        } else {
            ratio = 1 - ratio
        }

        this.options.onRender({ ratio })
    }

    resize() {
        this.options.onBeforeResize?.()

        const rect = this.element.getBoundingClientRect()
        this.rect = {
            documentTop: Scroll.getScroll().y + rect.top,
            height: rect.height
        }

        this.options.onResize?.({
            rect: this.rect
        })

        this.update()
    }
}